











export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Generating export',
    },
  },
}
